import React from 'react';
import Card from '../card/Card';
import { Scatter } from 'react-chartjs-2';

export default class MetricScatterChart extends React.Component {
  render() {
    const {
      title,
      yAxisLabel = '',
      xAxisLabel = 'Building',
      averageText = '',
      points = [],
      labels = [],
      height = 260,
      withLine = true,
      color = '#5B8FF9',
      showAverageBadge = false,
      hideInlineTitle = false,
    } = this.props;

    const data = {
      datasets: [
        {
          label: title,
          data: points.map((y, idx) => ({ x: idx + 1, y })),
          backgroundColor: color,
          borderColor: color,
          borderWidth: 2,
          pointRadius: 5,
          pointHoverRadius: 6,
          showLine: withLine,
          fill: false,
        },
      ],
    };

    const maxY = Math.max(50, Math.ceil((Math.max(...points, 0) + 5) / 10) * 10);
    // Ensure x-axis has at least 5 ticks, so single point doesn't appear at far right
    const maxX = Math.max(5, points.length + 1);

    const options = {
      maintainAspectRatio: false,
      legend: { display: false },
      elements: {
        line: {
          tension: 0.2,
        },
      },
      scales: {
        xAxes: [
          {
            type: 'linear',
            position: 'bottom',
            ticks: { min: 0, max: maxX, stepSize: 1, callback: v => (Number.isInteger(v) ? v : null) },
            scaleLabel: { display: true, labelString: xAxisLabel },
          },
        ],
        yAxes: [
          {
            ticks: { min: 0, max: maxY },
            scaleLabel: { display: true, labelString: yAxisLabel },
          },
        ],
      },
      tooltips: {
        callbacks: {
          title: items => {
            const idx = items[0].index;
            return labels[idx] || `Building ${items[0].xLabel}`;
          },
          label: item => `${yAxisLabel}: ${Number(item.yLabel).toFixed(2)}`,
        },
      },
    };

    const badgeStyle = {
      backgroundColor: '#ff3b30',
      color: 'white',
      borderRadius: 18,
      padding: '14px 18px',
      fontWeight: 600,
      minWidth: 200,
      textAlign: 'center',
      alignSelf: 'center',
    };

    return (
      <Card padding={true}>
        <div style={{ display: 'flex', gap: 16 }}>
          <div style={{ flex: 1, minHeight: height, position: 'relative', paddingTop: hideInlineTitle ? 0 : 40 }}>
            {!hideInlineTitle && title ? (
              <div
                style={{
                  position: 'absolute',
                  top: 8,
                  left: 12,
                  background: 'rgba(255,255,255,0.95)',
                  padding: '6px 12px',
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#333',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                  zIndex: 1,
                  pointerEvents: 'none',
                }}
              >
                {title}
              </div>
            ) : null}
            <Scatter data={data} options={options} height={height} />
          </div>
          {showAverageBadge && averageText ? (
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <div style={badgeStyle}>{averageText}</div>
            </div>
          ) : null}
        </div>
      </Card>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/charts/MetricScatterChart.js